(function () {
  const skipMenuNavigationTransitionKey = 'skip-header-drawer-navigation-transition';

  if (window.BAFRuntime && window.BAFRuntime.disableViewTransitions) {
    const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
    const viewTransitionMeta = document.querySelector('meta[name="view-transition"]');

    if (viewTransitionRenderBlocker) viewTransitionRenderBlocker.remove();
    if (viewTransitionMeta) viewTransitionMeta.setAttribute('content', 'none');
    return;
  }

  //Remove the view transition render blocker if the user has reduced motion enabled
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
    if (viewTransitionRenderBlocker) viewTransitionRenderBlocker.remove();
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;
  const session = {
    get(key) {
      try {
        return sessionStorage.getItem(key);
      } catch (error) {
        return null;
      }
    },
    set(key, value) {
      try {
        sessionStorage.setItem(key, value);
      } catch (error) {}
    },
    remove(key) {
      try {
        sessionStorage.removeItem(key);
      } catch (error) {}
    },
  };

  /**
   * @param {PageSwapEvent} event
   */
  window.addEventListener('pageswap', async (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;
    const skipMenuNavigationTransition = session.get(skipMenuNavigationTransitionKey) === 'true';

    if (skipMenuNavigationTransition) {
      viewTransition.skipTransition();
      session.remove('custom-transition-type');
      return;
    }

    // Cancel view transition on user interaction to improve INP (Interaction to Next Paint)
    ['pointerdown', 'keydown'].forEach(eventName => {
      document.addEventListener(eventName, () => {
        viewTransition.skipTransition();
      }, { once: true });
    });

    // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      session.set('custom-transition-type', transitionType);
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      session.remove('custom-transition-type');
    }
  });

  /**
   * @param {PageRevealEvent} event
   */
  window.addEventListener('pagereveal', async (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;
    const customTransitionType = session.get('custom-transition-type');
    const skipMenuNavigationTransition = session.get(skipMenuNavigationTransitionKey) === 'true';

    if (skipMenuNavigationTransition) {
      viewTransition.skipTransition();
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      session.remove(skipMenuNavigationTransitionKey);
      session.remove('custom-transition-type');
      return;
    }

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await viewTransition.finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      idleCallback(() => {
        session.remove('custom-transition-type');
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute('data-view-transition-type');
        });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  /**
   * Checks whether an Event object is carrying a `viewTransition` property
   * (as used by the View Transition API) and narrows the type accordingly.
   *
   * @template {Event} T
   * @param {T} event
   * @returns {event is T & { viewTransition: ViewTransition }}
   */
  function hasViewTransition(event) {
    return typeof ViewTransition !== 'undefined' && 'viewTransition' in event && event.viewTransition instanceof ViewTransition;
  }
})();
